import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { UserService } from 'app/core/services/user.service';
import { STORAGE_KEYS } from 'app/core/storage/storage-prefix';
import { ADMIN_ERROR_404_PATH } from './admin-permission.utils';

export const LandingErrorRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userService = inject(UserService);
  const hasLoginState = !!localStorage.getItem(STORAGE_KEYS.AUTH.ACCESS_TOKEN) && !!userService.userInfo;

  if (hasLoginState) {
    return of(router.parseUrl(ADMIN_ERROR_404_PATH));
  }

  return of(true);
};
